/**
 * @generated SignedSource<<5c2967d337ea2823469d63f8152ceb10>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageDateEditTabs_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateEditFlight_data">;
  readonly " $fragmentType": "PackageDateEditTabs_data";
};
export type PackageDateEditTabs_data$key = {
  readonly " $data"?: PackageDateEditTabs_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateEditTabs_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageDateEditTabs_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageDateEditFlight_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "32be91279db4b639cb6ee4e8910ade83";

export default node;
